import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

export const calculator = {
  namespaced: true,
  state: {
    calculator: null,
    calculationResult: null,
  },
  actions,
  getters,
  mutations
};
